import newrelic from 'newrelic';

import { stripDynamicValues } from '@common/utils/stripDynamicValues';

/**
 * whether to log to new relic
 */
const shouldLogToNewRelic = typeof newrelic === 'object' && newrelic;

/**
 * log request to new relic
 */
export const logRequestToNewRelic = (url: string, request: Request) => {
    if (
        shouldLogToNewRelic &&
        typeof newrelic.addCustomAttributes === 'function' &&
        typeof newrelic.startSegment === 'function'
    ) {
        newrelic.addCustomAttributes({
            'http.method': request.method,
            'http.url': stripDynamicValues(url),
            'http.headers': JSON.stringify(Object.fromEntries(request.headers || [])),
            'request.timestamp': Date.now(),
        });

        return newrelic.startSegment(
            `API ${request.method} ${stripDynamicValues(url || '')}`,
            true,
            () => request,
        );
    }

    return request;
};
